/**
 * Whether the app is running as an installed PWA (launched from the home screen) rather than in a
 * plain browser tab. Chromium/Android/desktop expose this through the `display-mode: standalone`
 * media query; iOS Safari never matches it and instead sets the legacy, non-standard
 * `navigator.standalone` boolean. Either signal means "installed", so no install nudge is needed.
 */
export const isRunningStandalone = (): boolean => {
  const displayModeStandalone = window.matchMedia?.('(display-mode: standalone)').matches ?? false
  const iosStandalone = (window.navigator as Navigator & { standalone?: boolean }).standalone === true

  return displayModeStandalone || iosStandalone
}
